var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "28px",
    height: "28px",
    viewBox: "0 0 28 28",
    style: {
      enableBackground: "new 0 0 28 28"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0,14C0,6.3,6.3,0,14,0c7.7,0,14,6.3,14,14c0,7.7-6.3,14-14,14C6.3,28,0,21.7,0,14z M2.8,14 c0,6.2,5,11.2,11.2,11.2c0,0,0,0,0,0c6.2,0,11.2-5,11.2-11.2c0,0,0,0,0,0c0-6.2-5-11.2-11.2-11.2c0,0,0,0,0,0 C7.8,2.8,2.8,7.8,2.8,14C2.8,14,2.8,14,2.8,14L2.8,14z M12.1,19.9V15c0-1,0.8-1.7,1.7-1.7c0,0,0,0,0,0c1,0,1.7,0.8,1.7,1.7v4.8 c0,1-0.8,1.7-1.7,1.7c0,0,0,0,0,0C12.9,21.6,12.1,20.8,12.1,19.9C12.1,19.9,12.1,19.9,12.1,19.9L12.1,19.9z M12.1,8.5 c0-1,0.8-1.7,1.7-1.7c0,0,0,0,0,0c1,0,1.7,0.8,1.7,1.7c0,1-0.8,1.7-1.7,1.7C12.9,10.3,12.1,9.5,12.1,8.5C12.1,8.5,12.1,8.5,12.1,8.5 L12.1,8.5z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.ca81ed513c552351f2f9e26c0ef0b0ed.svg";
export { ForwardRef as ReactComponent };